import { FC, PropsWithChildren } from 'react';
import classnames from 'classnames';

import { FormHelperRenderer } from '@hh.ru/magritte-ui-form-helper/FormHelperRenderer';
import { FieldsGroupHelperProps } from '@hh.ru/magritte-ui-form-helper/types';
import { useFormHelperState, FormHelperStateProvider } from '@hh.ru/magritte-ui-form-helper/useFormHelperState';

import styles from './form-helper.less';

export const FieldsGroupHelper: FC<PropsWithChildren<FieldsGroupHelperProps>> = ({
    children,
    description,
    errorMessage,
    invalid,
    disabled,
    descriptionId,
    topSpacing = 8,
    'data-qa': dataQa = 'fields-group-helper-container',
    inline = false,
}) => {
    const formHelperState = useFormHelperState({
        description,
        errorMessage,
        invalid,
        disabled,
    });
    return (
        <div data-qa={dataQa} className={classnames({ [styles.fieldsGroupHelperInline]: inline })}>
            <FormHelperStateProvider {...formHelperState}>{children}</FormHelperStateProvider>
            <FormHelperRenderer
                {...formHelperState}
                disabled={disabled}
                descriptionId={descriptionId}
                topSpacing={topSpacing}
                errorMessage={errorMessage}
                description={description}
            />
        </div>
    );
};
